import applyMessageActionOperation from 'owa-service/lib/operation/applyMessageActionOperation';
import applyMessageActionRequest from 'owa-service/lib/factory/applyMessageActionRequest';
import itemId from 'owa-service/lib/factory/itemId';
import messageAction from 'owa-service/lib/factory/messageAction';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
/**
 * Schedule item service
 * @param itemIds the itemIds to be scheduled
 * @param unschedule is this an unschedule request
 * @param scheduleReturnTime the time item will return
 * @return the ApplyMessageActionResponseMessage
 */
export default function scheduleItemsService(itemIds, unschedule, scheduleReturnTime) {
    var requestBody = configureRequestBody(itemIds, unschedule, scheduleReturnTime);
    return applyMessageActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
/**
 * Configure the request body
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage body
 */
function configureRequestBody(itemIds, unschedule, scheduleReturnTime) {
    return applyMessageActionRequest({
        MessageAction: messageAction({
            Action: unschedule ? 'Unschedule' : 'Schedule',
            ScheduleReturnTime: unschedule ? null : scheduleReturnTime.toISOString(),
        }),
        Ids: itemIds.map(function (itemIdValue) { return itemId({ Id: itemIdValue }); }),
    });
}
//# sourceMappingURL=scheduleItemsService.js.map